import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import ConsultationModal from './ConsultationModal';
import MobileCTABar from './MobileCTABar';

export default function Layout() {
  const [modal, setModal] = useState(false);
  const openSchedule = () => setModal(true);
  const location = useLocation();
  const hideChrome = location.pathname.startsWith('/admin') || location.pathname.startsWith('/case-study');

  return (
    <div className="App">
      {!hideChrome && <Navbar onSchedule={openSchedule} />}
      <main>
        <Outlet context={{ openSchedule }} />
      </main>
      {!hideChrome && <Footer />}
      {!hideChrome && <div className="md:hidden" style={{ height: 68 }} />}
      {!hideChrome && <MobileCTABar onSchedule={openSchedule} />}
      <ConsultationModal open={modal} onClose={() => setModal(false)} />
    </div>
  );
}
